import { CATEGORY_PATH } from '@shopgate/pwa-common-commerce/category/constants';

export const a11yNavEntries = [
  {
    title: 'navigation.categories',
    link: CATEGORY_PATH,
  },
];
